/**
 * Single source of truth for book titles.
 * English titles match the Amazon listings and MUST be used everywhere
 * (biography text, cards, schema) so they cannot diverge.
 */
export type BookId = "space" | "loneliness" | "ai" | "climate";

export type BookTitle = {
  id: BookId;
  /** Canonical English title (matches the Amazon listing) */
  titleEn: string;
  /** Turkish original title */
  titleTr: string;
  year: string;
  amazon?: string;
};

export const BOOK_TITLES: Record<BookId, BookTitle> = {
  space: {
    id: "space",
    titleEn: "Hayatı Yaşanır Kılan, Boşluktur",
    titleTr: "Hayatı Yaşanır Kılan, Boşluktur",
    year: "2026",
  },
  loneliness: {
    id: "loneliness",
    titleEn: "The Loneliness Economy",
    titleTr: "Yalnızlık A.Ş.",
    year: "2026",
    amazon: "https://www.amazon.com/dp/B0H59HPG62",
  },
  ai: {
    id: "ai",
    titleEn: "The Two Faces of Power: AI and the Future of Humanity",
    titleTr: "Yapay Zekâ: Gücün İki Yüzü",
    year: "2024",
    amazon: "https://www.amazon.com/dp/B0H58HHS3B",
  },
  climate: {
    id: "climate",
    titleEn: "It's Not a Climate Crisis, It's a Human Crisis",
    titleTr: "İklim Değil, İnsanlık Krizi",
    year: "2023",
    amazon: "https://www.amazon.com/dp/B0H598BYTV",
  },
};

/** Ordered newest-first, as displayed on the books/about pages. */
export const BOOK_ORDER: BookId[] = ["space", "loneliness", "ai", "climate"];

export const DISCLOSURE_EN =
  "This site is a personal publication; the views expressed here are his own and do not represent any institution.";

export const DISCLOSURE_TR =
  "Bu site kişisel bir yayındır; buradaki görüşler yazarın kendisine aittir ve herhangi bir kurumu bağlamaz.";
